import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Injector,
  OnDestroy,
  OnInit
} from '@angular/core';
import {ICloseReturnType, PlaceholderChildComponent} from '@ispm/layout/classes/placeholder-child-component.abstract';
import {DynamicFormModalPayload} from '@ispm/dynamic-form/classes/dynamic-form-modal-payload.class';
import {modalResponse} from '@ispm/layout/constants/modal-responses.enum';
import {DynamicFormModalResponse} from '@ispm/dynamic-form/classes/dynamic-form-modal-response.class';
import {cloneDeep, uniq, get, set, isEmpty, remove, groupBy, has} from 'lodash';
import {catchError} from 'rxjs/operators';
import {Observable} from 'rxjs';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';
import {AgregationService} from '@ispm-client/modules/aggregator/services';
import {DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import {Store} from '@ngrx/store';
import {IgenomicsState} from '@ispm/core/interfaces/genomics-state.interface';
import {CORE_ACTIONS} from '@ispm/core/constants/core-actions.constant';
import {GroupingAndOrderingService} from '@ispm/shared/services/grouping-and-ordering.service';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {TestBarActionTypes} from '@ispm/test/store/test-bar.actions';
import {ContextProviderService} from '@ispm-client/modules/context-provider/services/context-provider.service';
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import {WorkflowUtilService} from '@ispm-client/modules/aggregator/services/workflow-util.service';
import {TranslateService} from "@ngx-translate/core";
import {CONSTANTS, NOTIFICATION_MESSAGE} from '@ispm-client/modules/aggregator/services/consts';
import {ConfirmModalLoaderPayload} from "@ispm/layout/classes/confirm-modal-loader-payload";
import {OrganizationFormMode} from "../../../../ispm-admin/app/org-admin-settings/organizations/components/organization-form/org-admin-organization-form.component";
import {ModalLoaderNgjsService} from "@ispm/layout/services/modal-loader-ngjs.service";
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {OrderService} from "@ispm-client/modules/orders/services/order.service";
@Component({
  selector: 'gen-eligibility',
  templateUrl: './eligibility.component.html',
  styleUrls: ['./eligibility.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('Eligibility')
export class EligibilityComponent extends PlaceholderChildComponent<IPanCancerModalPayLoad, DynamicFormModalResponse> implements OnInit, IWidgetItem, OnDestroy {
  widgetUpdateValueCallback: (value) => void;

  public valid: boolean;
  public submitted: boolean[];
  public hasUpdatedFields: boolean;
  public isEditMode: boolean = false;
  public createMode: boolean = false;
  public enableEditButton: boolean = false;
  private buttonSubmitted: boolean = false;
  public resetFrom: boolean = false;
  public initDataComposerCall: boolean = true;
  public showProgressBar: boolean = false;
  private disableTestActionByValidation: boolean = false;
  public showIndicators: boolean = false;
  public dataRecieved: boolean[] = [];
  public isdataRecieved: boolean = false;
  public workflowStatus: string;
  public isWorkflowFrozen: boolean = false;
  public freezeDataBasedOnStatus: string[] = [];
  public isWorkflowDataInProgress: boolean = false;

  constructor(private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private _changeDetector: ChangeDetectorRef,
              private _agregationService: AgregationService,
              private modalLoader: DynamicModalLoaderService,
              private _store: Store<IgenomicsState>,
              private injector: Injector,
              private _groupingService: GroupingAndOrderingService,
              private _contextProviderService: ContextProviderService,
              private authService: AuthenticationService,
              private _formHandlerService: FormHandlerService,
              private _workflowUtilService: WorkflowUtilService,
              private _modalLoaderService: ModalLoaderNgjsService,
              private routerManagerService: RouterManagerService,
              private orderService: OrderService,
              private _translate: TranslateService) {
    super();

  }

  set widgetData(widgetData: any) {
  }

  set widgetConfig(_itemConfig: any) {
    this.payload = get(_itemConfig, 'widgetPayload');
    this.showProgressBar = get(this.payload, 'showProgressBar');
    this.showIndicators = get(this.payload, 'showIndicators');
    if (get(this.payload, 'dataComposer') && this.initDataComposerCall) {
      this._contextProviderService.fetchDataFromDataBindings(get(this.payload, 'dataComposer'));
      this.initDataComposerCall = false;
    }
    const param = this.routerManagerService.parameters;
    this.isEditMode = this.payload.isEditMode;
    if ((get(param, 'type', '') === 'patient') && (get(param, 'id', '') === 'create')) {
      this.createMode = true;
      this.isEditMode = true;
    }
    this.enableEditButton = get(this.payload, 'enableEditButton', false);
    let requiredPermissionsIds = get(this.payload, 'requiredPermissionsIds');
    if (requiredPermissionsIds) {
      this.isEditMode = this.authService.doesUserHasPermission(get(requiredPermissionsIds, 'write'));
    }
    if (get(this.payload, 'permitOnlyAssignee')) {
      this._workflowUtilService.checkIfPerformer().subscribe(isPerformer => {
        this.isEditMode = this.isEditMode && isPerformer;
      });
    }
    if (get(this.payload, 'freezeDataBasedOnStatus')) {
      this.freezeDataBasedOnStatus = get(this.payload, 'freezeDataBasedOnStatus');
    }
    this._workflowUtilService.getCurrentWorkflow().subscribe(order => {
      this.workflowStatus = get(order, 'workflowRequest.latestRevisionStatus', '');
      if(this.freezeDataBasedOnStatus.length > 0) {
        this.isWorkflowFrozen = this.freezeDataBasedOnStatus.includes(this.workflowStatus.toLowerCase()) && get(order, 'snapshotEditor', false);
        if(this.isWorkflowFrozen &&  !get(order, 'snapshotEditor', false)) {
          this.isWorkflowDataInProgress = true;
        }
      }

    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.submitted = [];
    // this.buttonSubmitted =  this.payload.buttonSubmitted;
    this.showProgressBar = get(this.payload, 'showProgressBar');
    this.disableTestActionByValidation = get(this.payload, 'disableTestActionByValidation');
    if (get(this.payload, 'dataComposer') && this.initDataComposerCall) {
      this._contextProviderService.fetchDataFromDataBindings(get(this.payload, 'dataComposer'));
      this.initDataComposerCall = false;
    }
    if (get(this.payload, 'isEditMode')) {
      this.isEditMode = get(this.payload, 'isEditMode', false);
    }
    if (this.isWorkflowFrozen) {
      this.payload.formPayloadFrozen.forEach((item, index) => {
        this.submitted.push(false);
        this.dataRecieved.push(false);
        this._formHandlerService.getForm(this.payload.formPayloadFrozen[index].formId) //Forms pre fetching
        if (this.payload.formPayloadFrozen[index].formData) {
          this.payload.formPayloadFrozen[index].formData = cloneDeep(this.payload.formPayloadFrozen[index].formData);
        }
        if (!this.payload.formPayloadFrozen[index].hasOwnProperty('formVertical')) {
          this.payload.formPayloadFrozen[index]['formVertical'] = true;
        }
        if (this.createMode) {
          delete this.payload.formPayloadFrozen[index].formData;
        }
      });
    } else {
      this.payload.formsPayload.forEach((item, index) => {
        this.submitted.push(false);
        this.dataRecieved.push(false);
        this._formHandlerService.getForm(this.payload.formsPayload[index].formId) //Forms pre fetching
        if (this.payload.formsPayload[index].formData) {
          this.payload.formsPayload[index].formData = cloneDeep(this.payload.formsPayload[index].formData);
        }
        if (!this.payload.formsPayload[index].hasOwnProperty('formVertical')) {
          this.payload.formsPayload[index]['formVertical'] = true;
        }
        if (this.createMode) {
          delete this.payload.formsPayload[index].formData;
        }
      });
    }


  }

  updateValidate(validate: boolean, i) {
    this.submitted[i] = validate;
    if (this.disableTestActionByValidation) {
      this.showOrHideTestBarConfirmButton(false);
      if (this.submitted.every(valid => valid)) {
        this.showOrHideTestBarConfirmButton(true);
      }
    }
  }

  updateFormData(formData, index) {
    this.resetFrom = false;
    if (formData.updated) {
      this.hasUpdatedFields = true;
    }
    this.payload.formsPayload[index].formData = formData.form;
    if (!get(this.payload.formsPayload[index], 'updatedFields')) {
      set(this.payload.formsPayload[index], 'updatedFields', []);
    }
    get(this.payload.formsPayload[index], 'updatedFields').push(...formData.updated);
  }

  beforeClose(_modalResponse?: modalResponse): DynamicFormModalResponse & ICloseReturnType {
    this.buttonSubmitted = true;
    if (!this.submitted.every(valid => valid)) {
      this.notificationMessageService.error(this.notificationMessage.Please_fill_required_fields);
      return {isValid: false};
    }

    let dataAvailable = this._groupingService.getNotifyDataUpdated();
    if (!this.hasUpdatedFields) {
      if (dataAvailable) {
        this.notificationMessageService.warning(this.notificationMessage.CLICK_ON_ADD_TO_THE_TABLE);
        return {isValid: false};
      } else {
        this.notificationMessageService.error(this.notificationMessage.NO_MODIFIED_DATA_TO_UPDATE);
        return {isValid: false};
      }

    }

    this._store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: true
    });


    const data = {
      formData: this.payload.formsPayload,
      isValid: true,
      hasUpdatedFields: this.hasUpdatedFields,
      responseType: _modalResponse
    };
    if (this.isEditMode) {
      const context = this;
      if ((data.responseType === modalResponse.approve) && data.isValid && !dataAvailable) {
        return context.submitForm(data)
          .then(resp => {
            this._store.dispatch({
              type: CORE_ACTIONS.SET_LOADER,
              payload: false
            });
            this.createMode ? this.notificationMessageService.success(this.notificationMessage.PATIENT_CREATED_SUCCESSFULLY) : this.notificationMessageService.success(this.notificationMessage.Patient_details_updated_successfully);
            return {isValid: !!resp, resp: resp, changed: true};
          })
          .catch(err => {
            this._store.dispatch({
              type: CORE_ACTIONS.SET_LOADER,
              payload: false
            });
            return {isValid: false};
          });
      } else if (dataAvailable) {
        this.notificationMessageService.warning(this.notificationMessage.CLICK_ON_ADD_TO_THE_TABLE);
        this._store.dispatch({
          type: CORE_ACTIONS.SET_LOADER,
          payload: false
        });
        return {isValid: false};
      }
    }
    this._changeDetector.markForCheck();
    return data;
  }


  /**
   * Submit dynamic form data
   * @param submittedData
   */
  submitForm(submittedData): Promise<any> {
    let refreshNeed;
    const postData = [];
    let postDataObj;
    const formsData = submittedData.formData;
    if (submittedData.hasUpdatedFields) {
      return new Promise((resolve, reject) => {
        for (const formItemData of formsData) {
          postDataObj = {'formId': formItemData.formId, 'formdata': []};
          const formData = formItemData.formData;
          if (formData) {
            const formKey = get(formItemData, 'key');
            for (const item of uniq(formItemData.updatedFields)) {
              const formItem = formData['' + item];
              if (Array.isArray(formItem) && !formData['noFlatten']) {
                postDataObj.formdata.push(...formItem.map(row => {
                  if (row['refreshNeed']) {
                    refreshNeed = row['refreshNeed'];
                    delete row['refreshNeed'];
                  }
                  return this.getRowData(row, item, formData, formKey);
                }).filter(row => {
                  if (!row['formId']) {
                    return false;
                  }
                  if (row.hasOwnProperty('changed')) {
                    if (!row['changed']) {
                      return false;
                    } else {
                      delete row['changed'];
                    }
                  }
                  return true;
                }));
              } else if (formItem && typeof formItem === 'object') {
                refreshNeed = refreshNeed ? refreshNeed : formData['refreshNeed'];
                const _formData = cloneDeep(formData);
                delete _formData['refreshNeed'];
                if (!(formItem.hasOwnProperty('formId'))) {
                  formItem['formId'] = _formData['formId'];
                }

                // TODO this is temp fix we need depend on another config item called needflatten
                // and based on that flatten if required @Viresh and @Deepak
                if (_formData['noFlatten']) {

                  if ((_formData.hasOwnProperty('noFlatten'))) {
                    delete _formData['noFlatten'];
                  }
                  _formData['_dataBindingIdentifier'] = item;
                  if (formKey) {
                    this._contextProviderService.addContext(_formData, formKey);
                  }
                  if (_formData['formId']) {
                    postDataObj.formdata.push(_formData);
                  }
                } else {
                  if (formItem.hasOwnProperty('code')) {
                    _formData['_dataBindingIdentifier'] = item;
                    if (formKey) {
                      this._contextProviderService.addContext(_formData, formKey);
                    }
                    if (_formData['formId']) {
                      postDataObj.formdata.push(_formData);
                    }
                  } else if (formItem.hasOwnProperty('flatten')) {
                    delete formItem['noFlatten'];
                    this.flattenNestedObjects(formItem, postDataObj, formKey, refreshNeed);
                  } else {
                    if (formItem['formId']) {
                      postDataObj.formdata.push(this.getRowData(formItem, item, _formData, formKey));
                    }
                  }
                }
              } else if (typeof formItem === 'string' || formItem === null) {
                refreshNeed = formData['refreshNeed'];
                delete formData['refreshNeed'];
                formData['_dataBindingIdentifier'] = item;
                if (formKey) {
                  this._contextProviderService.addContext(formData, formKey);
                }
                postDataObj.formdata.push(formData);
                break;
              }
            }
          }
          if (postDataObj.formdata.length > 0) {
            if (get(this.payload, 'aggregateDataByGroup')) {
              let tempFormData = postDataObj.formdata;
              let groupsData: any = remove(tempFormData, tempRow => {
                return tempRow.hasOwnProperty('dataGroupId');
              });
              groupsData = groupBy(groupsData, 'dataGroupId');
              for (let groupKey in groupsData) {
                let mergeRowData = {};
                let groupData = get(groupsData, groupKey);
                if (groupData && groupData.length > 0) {
                  for (let groupItem of groupData) {
                    mergeRowData = {...mergeRowData, ...groupItem};
                  }
                  delete mergeRowData['dataGroupId'];
                  tempFormData.push(mergeRowData);

                }
              }
              postDataObj.formdata = tempFormData;
            }
            postData.push(postDataObj);
          }
        }
        if (postData.length > 0) {
          this._agregationService.UpdateDataToServer(postData).pipe(
            catchError(err => {
              console.error('pan cancer dynamic form : Update dat to server failed : Error : ', err.message);
              this.notificationMessageService.error(this.notificationMessage.UNABLE_TO_UPDATE_PATIENT_DETAILS);
              reject(null);
              return Observable.throw(err);
            })
          ).subscribe(response => {
              if (response['code'] === 2) {
                if (refreshNeed) {
                  this.refreshNeed();
                }
                resolve(CONSTANTS.Patient_details_updated_successfully);
              } else if (response['code'] === 3) {
                this.notificationMessageService.warning(response['display']);
                reject(null);
              } else if (response['code'] === 4) {
                this.notificationMessageService.error(response['display']);
                reject(null);
              }
            },
            postErr => {
              this.notificationMessageService.error(this.notificationMessage.THERE_WAS_ERROR_DURING_UPDATE);
              reject(null);
            });
        } else {
          this.notificationMessageService.error(this.notificationMessage.NO_MODIFIED_DATA_TO_UPDATE);
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: false
          });
          reject(null);
        }
      });
    } else {
      return Promise.reject(null);
    }
  }


  /**
   * Get formatted row data
   * @param row
   * @param item
   * @param formData
   */
  getRowData(row, item, formData, formKey?: string) {
    if (row['requiredFields']) {
      for (const requiredField of row['requiredFields']) {
        row[requiredField] = formData[requiredField];
      }
      delete row['requiredFields'];
    }
    row['_dataBindingIdentifier'] = item;
    if (row['__gen-selection-list__unique-item-id__']) {
      delete row['__gen-selection-list__unique-item-id__'];
      if (formKey) {
        this._contextProviderService.addContext(row, formKey);
      }
    }
    if (formKey) {
      this._contextProviderService.addContext(row, formKey);
    }
    return row;
  }


  private refreshNeed() {
    const _routeManager: RouterManagerService = this.injector.get(RouterManagerService);
    _routeManager.reload();
  }


  /**
   * On button click
   * @param type
   */
  buttonClick(type: string) {
    switch (type) {
      case 'submit':
        if (!this.hasUpdatedFields) {
          this.notificationMessageService.error(this.notificationMessage.NO_MODIFIED_DATA_TO_UPDATE);
          return {isValid: false};
        }
        this.showOrHideProgressBar(true);
        this.submitForm({
          formData: this.payload.formsPayload,
          isValid: true,
          hasUpdatedFields: this.hasUpdatedFields
        }).then(data => {
          this.createMode ? this.notificationMessageService.success(this.notificationMessage.Patient_details_saved_successfully) : this.notificationMessageService.success(this.notificationMessage.Patient_details_updated_successfully);
          if (get(this.payload, 'triggerACRValidation')) {
            this.orderService.triggerAcrValidation(null);

          }
          if (get(this.payload, 'enableEditButton', false)) {
            this.isEditMode = false;
            this._changeDetector.markForCheck();
            this._changeDetector.detectChanges();
          }
          this.showOrHideProgressBar(false);
        }).catch(err => {
          this._store.dispatch({
            type: CORE_ACTIONS.SET_LOADER,
            payload: false
          });
        });
        break;
      case 'reset':
        this.resetFrom = true;
        break;
      case 'edit':
        this.isEditMode = true;
        this._changeDetector.markForCheck();
        break;
      case 'cancel':
        this.cancelClick();
        break;
    }
  }

  cancelClick() {
    this._modalLoaderService.popupModal('confirm',
      ConfirmModalLoaderPayload.builder()
        .setTitle(this._translate.instant('DISCARD_DATA') || 'Discard Data')
        .setContent(this._translate.instant('ADMIN_UN_SAVED_CHANGES') || 'Canceling will return without saving your changes. Are you sure?')
        .setDeclineButtonText(this._translate.instant('No') || 'No')
        .setApproveButtonText(this._translate.instant('Yes') || 'Yes'),
      'INFO').subscribe(response => {
      if (get(response, 'payload') === modalResponse.approve) {
        this.isEditMode = false;
        this._changeDetector.markForCheck();
      }
    });
  }

  /**
   * Show progress bar
   * @param show
   */
  showOrHideProgressBar(show) {
    this._store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: show
    });
  }

  /**
   * Show test bar confirm button
   * @param show
   */
  showOrHideTestBarConfirmButton(show) {
    this._store.dispatch({
      type: TestBarActionTypes.AvailableConfirmButton,
      payload: show
    });
  }

  //This will be removed on flatten service integrated
  flattenNestedObjects(nestedObject, postDataObj, formKey, refreshNeed) {

    for (const item of Object.keys(nestedObject)) {
      const formItem = nestedObject['' + item];
      if (!isEmpty(formItem)) {
        if (Array.isArray(formItem) && !formItem['noFlatten']) {
          postDataObj.formdata.push(...formItem.map(row => {
            if (row['refreshNeed']) {
              refreshNeed = row['refreshNeed'];
              delete row['refreshNeed'];
            }
            return this.getRowData(row, item, formItem, formKey);
          }).filter(row => {
            if (!row['formId']) {
              return false;
            }
            if (row['selected'] || row['id']) {
              return true;
            }
            if (row.hasOwnProperty('changed')) {
              if (!row['changed']) {
                return false;
              } else {
                delete row['changed'];
                return true;
              }
            }
            return true;
          }));
        } else if (typeof formItem === 'object' && formItem['formId']) {
          refreshNeed = refreshNeed ? refreshNeed : formItem['refreshNeed'];
          const _formData = cloneDeep(formItem);
          delete _formData['refreshNeed'];

          // TODO this is temp fix we need depend on another config item called needflatten
          // and based on that flatten if required @Viresh and @Deepak
          if (_formData['noFlatten']) {

            if ((_formData.hasOwnProperty('noFlatten'))) {
              delete _formData['noFlatten'];
            }
            _formData['_dataBindingIdentifier'] = item;
            if (formKey) {
              this._contextProviderService.addContext(_formData, formKey);
            }
            postDataObj.formdata.push(_formData);
          } else {
            if (formItem.hasOwnProperty('code')) {
              _formData['_dataBindingIdentifier'] = item;
              if (formKey) {
                this._contextProviderService.addContext(_formData, formKey);
              }
              postDataObj.formdata.push(_formData);
            } else {
              postDataObj.formdata.push(this.getRowData(formItem, item, _formData, formKey));
            }
          }
        }
      }
    }
  }

  dataRecievedEvent(validate: boolean, i) {
    this.dataRecieved[i] = validate;
    this.isdataRecieved = this.dataRecieved.every(item => item);
  }

  ngOnDestroy(): void {
    this.payload = null;
    this._contextProviderService.clearContexts();
  }
}

interface IPanCancerModalPayLoad {
  showEditIcon?: boolean;
  isEditMode?: boolean;
  formsPayload?: DynamicFormModalPayload[];
  buttonSubmitted?: boolean;
  controls: any[];
  cssClass: string;
  requiredPermissionsIds?: any[];
  aggregateDataByGroup?: boolean;
  permitOnlyAssignee?: boolean;
  dataComposer?: any;
  disableTestActionByValidation?: boolean;
  showProgressBar?: boolean;
  showIndicators?: boolean;
  formPayloadFrozen?: DynamicFormModalPayload[];
}



